import ServiceApi from "../ServiceApi.js";

export default class ServiceUsersPricesSettings {
    static _microserviceName = 'free';

    static _requestRoutes = {
        getUsersPrices: "/admin/users",
        setUserPriceType: "/admin/users/price-type"
    };

    static async getUsersPrices(searchData = {}, sortData = {}) {
        const requestBody = this._getUsersPricesBefor(searchData, sortData);
        try {
            const responseBody = await ServiceApi.post(this._microserviceName, this._requestRoutes.getUsersPrices, requestBody);

            return responseBody?.data?.data ?? [];
        } catch (error) {
            const errorMessage = ServiceApi.getErrorMessage(error, "Не удалось получить типы цен пользователей");

            throw errorMessage;
        }
    }

    static _getUsersPricesBefor(searchData = {}, sortData = {}) {
        const requestBody = {
            ...searchData,
            sort: {
                field: sortData.key,
                direction: sortData.type
            }
        };

        return requestBody;
    }

    static async setUserPriceType(userId = "", priceType = "") {
        try {
            await ServiceApi.post(this._microserviceName, this._requestRoutes.setUserPriceType, { id: userId, priceType });
        } catch (error) {
            const errorMessage = ServiceApi.getErrorMessage(error, "Не удалось изменить тип цены пользователю");

            throw errorMessage;
        }
    }
}